import APIv2 from "./_apiv2";
import {MVEditor} from "./_multi-value-editor";


const ConnectionEditor = {
    connectionsList: [],
    
    renderAll(){
        this.someEvents();
        
        let $selectors = $("[data-connection]:not([data-connection='init'])");
        
        if($selectors.length === 0) return;
        
        $selectors.each( (key, element) => {
            this.renderForTag(element)
        })
    },
    
    renderForTag(element, options = {}){

        options = $.extend({
            placeholder: "",
            plugins: ['remove_button'],
            preload: 'focus',
            valueField: 'id',
            labelField: 'name',
            searchField: 'name',
            sortField: 'name',
            dropdownParent: 'body',
            create: function (name, callback) {
                window['APIv2']._request('workspace/connection', {
                    name: name,
                    workspace_id: window['APIv2'].workspace.id,
                }, 'POST').then((data) => {
                    // Append new option to the cache-list
                    ConnectionEditor.connectionsList.push(data.connection);

                    $("[data-connection].selectized").each(function (num, el) {
                        // Clean old cache for other selectized lists
                        el.selectize.clearOptions()
                    });

                    // End inner logic
                    callback(data.connection);
                })
            },
            load(query, callback){
                if(query.length > 0){
                    return [];
                }

                if(ConnectionEditor.connectionsList.length){
                    callback([ConnectionEditor.connectionsList]);
                } else {
                    window['APIv2']._request('workspace/connections', {
                        query: query,
                        workspace_id: window['APIv2'].workspace.id,
                    }).then((data) => {
                        ConnectionEditor.connectionsList = data.list;
                        callback([ConnectionEditor.connectionsList]);
                    })
                }
            },
            /*onItemAdd(value, $item){
                console.log('selected added:', value, $item)
            },*/
            onChange(value){
                
            }

        }, options);
        
        $(element).selectize(options);

        return element.selectize;
    },

    updateOriginalViewIfInTable(selectizeInst, entryId, callback = null){
        if(selectizeInst.$control.closest('[data-connection-rw]').length > 0){
            
            let $originalPart = selectizeInst.$control.closest('[data-connection-rw]').find('.inline-original');
            
            $.post('/api/v1/editable/original', {
                id: entryId,
                field: 'connection'
            }, function (response) {
                $originalPart.find('.preview').html(response);
                
                if(callback){
                    callback();
                }
            });
        }
    },
    
    mode($editorEl, mode){
        let $editorPart = $editorEl.find('.inline-editor');
        let $originalPart = $editorEl.find('.inline-original');
        
        $originalPart.toggleClass('d-none', (mode === 'editor'));
        $editorPart.toggleClass('d-none', (mode === 'preview'));

        if(mode === 'preview'){


            $.post('/api/v1/editable/editor', {
                id: $editorEl.data('id'),
                field: 'connection'
            }, function (response) {
                $editorPart.find('.edit-select-wrap').html(response);

                $editorPart.find('button[data-close-editor]').off('click');
                $editorPart.find('button[data-connection-editor-save]').off('click');
            });
            
        } else {

            $editorPart.find('button[data-connection-editor-save]').prop("disabled", false);
            $editorPart.find('button[data-connection-editor-save]').removeClass('oc-loading');
            
            $editorPart.find('button[data-close-editor]').one('click', () => {
                this.mode($editorEl, 'preview');

                if($editorPart.find("[data-connection].selectized").length > 0){
                    $editorPart.find("[data-connection].selectized")[0].selectize.destroy();
                }
                
            });
            
            $editorPart.find('button[data-connection-editor-save]').one('click', () => {
                
                let element = $editorPart.find("[data-connection].selectized")[0];
                let selectizeInst = element.selectize;

                $editorPart.find('button[data-connection-editor-save]').prop("disabled", true);
                $editorPart.find('button[data-connection-editor-save]').addClass('oc-loading');
                
                $.request('onBulkAction', {
                    data: {
                        action: "edit",
                        ids: element.dataset.id,
                        field: 'connections',
                        value: selectizeInst.getValue()
                    },
                    complete: function () {

                        //selectizeInst.destroy();
                        
                        ConnectionEditor.updateOriginalViewIfInTable(selectizeInst, element.dataset.id, function () {
                            ConnectionEditor.mode($editorEl, 'preview');
                        });

                        this.complete();
                    }
                })

                
            });
            
            
            this.renderForTag($editorPart.find('select[data-connection]')[0]);
            
            //MVEditor.initPhoneTypeSelectrs($editorPart);
        }
    },
    someEvents()
    {
        $('[data-connection-rw]:not(.ie-init)')
            .on('dblclick', function () {
                $(this).find('button[data-enable-connection-editor]').trigger('click')
            })
            .addClass('ie-init');
        $('button[data-enable-connection-editor]:not(.ie-init)')
            .on('click', function () {
                if(! $(this).closest('div[data-connection-rw]').hasClass('d-none')){
                    ConnectionEditor.mode($(this).closest('div[data-connection-rw]'), 'editor')
                }
            })
            .addClass('ie-init');
        
    }
}

export { ConnectionEditor };
